import React from "react";
import PropTypes from "prop-types";
import countries from "country-region-data/data.json";

const CountryOptions = () =>
    countries.map(({ countryName, countryShortCode }) => (
        <option key={countryShortCode} value={countryShortCode}>
            {countryName}
        </option>
    ));

const RegionOptions = ({ regions }) => {
    if (regions && regions.length > 0) {
        return regions.map(({ stateName, stateCode }) => (
            <option key={stateCode} value={stateName}>
                {stateName}
            </option>
        ));
    }
    return [];
};

RegionOptions.propTypes = {
    // ⬇️ Grandfathered in from before Airbnb rules
    // eslint-disable-next-line react/forbid-prop-types
    regions: PropTypes.array.isRequired,
};

export { CountryOptions, RegionOptions };
